import { render, staticRenderFns } from "./slider-mention-item.vue?vue&type=template&id=0e6228d5&scoped=true&"
import script from "./slider-mention-item.vue?vue&type=script&lang=js&"
export * from "./slider-mention-item.vue?vue&type=script&lang=js&"
import style0 from "./slider-mention-item.vue?vue&type=style&index=0&id=0e6228d5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6228d5",
  null
  
)

export default component.exports